<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  


<div *ngIf="!isLoading">
    <mat-toolbar class="toolbar">

        <!-- TODO: activate as soon as menu items are ready -->

        <!-- <button mat-icon-button (click)="clickMenu()" class="example-icon" aria-label="Example icon-button with menu icon">
            <mat-icon>menu</mat-icon>
        </button> -->
        <button mat-icon-button (click)="onReload()" class="example-icon">
            <mat-icon class="matIcon-lg">home</mat-icon>
        </button>
        <span id="kkis_advertise">KKIS-B2B Portal</span>
        <span class="toolbar-spacer"></span>

        <!-- ***** HAS BEEN MOVED ABOVE CATEGORIES ***** -->
        
        <!-- <mat-form-field style="padding-top: 10px; padding-right: 40px;">
            <mat-label>Suche</mat-label>
            <input type="text" matInput name="search" [(ngModel)]="search" (keydown.enter)="onSearch()">
            <button matSuffix mat-button (click)="onSearch()"><mat-icon class="matIcon-md-grey">search</mat-icon></button>
        </mat-form-field> -->


        <span>{{ loggedInUserName }}</span>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu" aria-label="Menu for the account with login and logout">
            <mat-icon class="matIcon-lg">account_circle</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu">
            <button mat-menu-item *ngIf="!isLoggedIn" (click)="onLogin()">
                <mat-icon>login</mat-icon>
                <span>Anmelden</span>
            </button>
            <button mat-menu-item *ngIf="isLoggedIn" (click)="onShowAccount()">
                <mat-icon>badge</mat-icon>
                <span>Mein Konto</span>
            </button>
            <mat-divider *ngIf="isLoggedIn"></mat-divider>
            <button mat-menu-item *ngIf="isLoggedIn" (click)="onLogout()">
                <mat-icon>logout</mat-icon>
                <span>Abmelden</span>
            </button>
        </mat-menu>
        <button mat-icon-button id="shoppingCart" matBadge="{{numberWarenkorbItems}}" matBadgeColor="warn" matTooltip="Warenkorb" (click)="onShowWarenkorb()">
            <mat-icon class="matIcon-lg-grey" [inline]="true">shopping_cart</mat-icon>
        </button>
    </mat-toolbar>
</div>